<template>
  <div class="rpc_modal">
    <div class="header">
      <h4 class="title">
        RPC Info
      </h4>
    </div>
    <div class="content">


      <div class="row">
        <div class="col-md-4">
          <label> Команда </label>
          <tree-select
              :options="commands"
              v-model="main_command.command_id"
              placeholder="Команда"
              :clearable="false"
          />
        </div>

        <div class="col-md-4">
            <label v-if="command_params !== null"> Параметры </label>
            <tree-select
                v-if="command_params !== null"
                :options="command_params"
                v-model="main_command.command_params_id"
                placeholder="Параметры"
                :clearable="false"
            />
        </div>

        <div class="col-md-2">
          <fg-input
            type="number"
            :min=0
            :max=3600
            v-model="main_command.timeout"
            placeholder="Таймаут (секунд)"
            label="Таймаут (секунд)"
          />
        </div>

        <div class="col-md-2">
          <span
            :disabled="check_run_command"
            class="mdi btn btn-info btn-apply"
            @click.prevent="run_command"
          >
            Отправить
          </span>
        </div>
      </div>

      <div class="row" v-if="check_user_params_in_command_params">
        <div class="col-md-12">
          <fg-input
              type="text"
              :min=0
              :max=3600
              v-model="main_command.user_params"
              placeholder="Пользовательские параметры"
              label="Пользовательские параметры"
          />
        </div>
      </div>

      <div class="history">
        <div v-if="load" class="load">
          <scale-loader />
        </div>
        <div id="terminal" class="terminal" ref="terminal"></div>
      </div>
    </div>

    <div class="footer">
      <button
        type="submit"
        class="btn btn-danger btn-fill btn-wd marginButton"
        @click.prevent="cancel"
      >
        {{ translate('close_modal') }}
      </button>
    </div>
  </div>

</template>
<script>

import { Terminal } from 'xterm'
import 'xterm/css/xterm.css'
import { FitAddon } from "xterm-addon-fit"

export default {
  name: "RPC_Modal",
  props: ['fid', 'history', 'list'],
  data () {
    return {
      history_list: this.history,
      command_list: this.list,
      load: false,
      main_command:{
        command_id: null,
        command_params_id: null,
        timeout: null,
        user_params: ""
      }
    }
  },
  computed:{
    commands(){
      return this.command_list.map((command) => {
        return {id: command.id, label: command.name}
      })
    },
    command_params(){
      if (!this.main_command.command_id) return null
      let select_command = this.command_list.find((item) => {
        return item.id === this.main_command.command_id
      })
      if (select_command.command_params === null) return null
      return Object.keys(select_command.command_params).map((index) => {
        return {id: +index, label: select_command.command_params[index].name}
      })
    },
    check_user_params_in_command_params(){
      if(!this.main_command.command_id && !this.main_command.command_params_id) return ""
      const select_command = this.command_list.find((item) => {
        return item.id === this.main_command.command_id
      })
      if (select_command.command_params === null) return null
      const select_params = select_command.command_params[this.main_command.command_params_id]
      return select_params.use_user_params
    },
    check_run_command(){
      return this.main_command.command_id == null || this.command_params !== null && this.main_command.command_params_id == null
    }
  },
  watch:{
    "main_command.command_id":{
      deep: false,
      handler(new_val){
        if (new_val !== null){
          let select_command = this.command_list.find((item) => {
            return item.id === this.main_command.command_id
          })
          this.main_command.timeout = select_command.timeout
          this.main_command.command_params_id = select_command.command_params !== null ? Number(Object.keys(select_command.command_params)[0]) : null
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
        window.addEventListener('resize', this.onResize);
    })

    let terminalContainer = document.getElementById('terminal')
    this.term = new Terminal({rows: 30, cols: 178, fontSize: 14})
    this.fitAddon = new FitAddon();
    this.term.open(terminalContainer)
    this.term._initialized = true
    this.term.loadAddon(this.fitAddon)

    this.term.onKey(e => {
      this.connection.send(JSON.stringify({ cmd: "run", data: e.key }))
    });

    for (let history of this.history_list) {
      this.term.write(this.get_date(history.ts) + " (" + history.user_name + ")")
      this.term.write('\r\n');
      this.term.write(history.in)
      this.term.write('\r\n');
      for (let i in history.out) {
        this.term.write(history.out[i])
        this.term.write('\r\n');
      }
      this.term.write('\r\n');
      this.term.write('\r\n');
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    check_command(id_command){
      if(this.$store.getters.WsGetStatus){
        let topic = `rpc_result.${id_command}`
        this.$store.dispatch("WS_Subscribe",{ topic: topic, func: (cmd) => {
            this.parse_data(cmd.data.output)
            this.$store.dispatch("WS_Unsubscribe",cmd.action)
          } })
      } else {
        this.interval = setInterval(() => {
          this.$http.v1.checkRPCCommand(id_command, (resp) => {
            if (resp.data.ts_end !== 0 && (resp.data.status >= 5 || resp.data.status === 3)) {
              this.parse_data(resp.data.out)
              clearInterval(this.interval)
            }
          })
        }, this.$store.getters.getCheckRpcCommand)
      }
    },
    parse_data(result){
      if (result) {
        for (let i in result) {
          this.term.scrollToBottom()
          this.term.write(result[i])
          this.term.write('\r\n');
        }
      } else {
        this.global_notify('warning', this.translate('no_data'))
      }
      this.load = false
    },
    run_command(){
      if (!this.check_run_command){
        this.load = true

        const main_command = {}
        Object.keys(this.main_command).forEach(key => {
          if(this.main_command[key] !== null && this.main_command[key] !== "")
          main_command[key] = this.main_command[key]
        })

        this.$http.v1.runRPCCommand(this.fid, main_command,(response) => {
          if (response.data.ts_end === 0) {
            this.term.write('\r\n');
            this.term.write(this.get_date(response.data.ts) + " (" + response.data.user_name + ")")
            this.term.write('\r\n');
            this.term.write(response.data.in)
            this.term.write('\r\n');

            this.check_command(response.data.id)
          }
        })
      }

    },
  }
}

</script>

<style lang='scss' scoped>
  .rpc_modal{
    padding: 10px;
    .header{
      padding: 10px 0;
      .title{
        font-size: 22px;
        font-weight: 600;
        margin: 0;
        text-align: center;
      }
    }
    .content{
      padding: 10px 0;

      .row{
        display: flex;
        align-items: flex-end;
        margin-bottom: 10px;

        .form-group {
          margin-bottom: 0;
        }

        .btn{
          width: 100%;
          height: 40px;
        }
      }

      .history{
        position: relative;
        .terminal{
          width:100%;
          overflow-x: scroll;
          &::-webkit-scrollbar{
            width: 10px;
            height: 10px;
          }
        }
        .load{
          position: absolute;
          top: calc(50% - 30px);
          right: calc(50% - 30px);
          padding: 10px;
          width: 60px;
          height: 60px;
          z-index: 9;
          background-color: #ffffffbb;
          border-radius: 5px;
        }
      }
    }
    .footer{
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .btn{
        margin: 0 5px;
        display: block;
      }
    }
  }

</style>
